import http from './http';

export default {
  all() {
    return http().get(`/v1/follow_up_sequence_step_templates`);
  },
  allForTemplate(templateId) {
    return http().get(`/v1/follow_up_sequence_step_templates/` + templateId);
  },
  create(step) {
    return http().post(`/v1/follow_up_sequence_step_templates`, step);
  },
  update(step) {
    return http().put(`/v1/follow_up_sequence_step_templates/${step.id}`, step);
  },
  delete(id) {
    return http().delete(`/v1/follow_up_sequence_step_templates/${id}`);
  },
}
